import { CommonModule } from '@angular/common';
import { Component, Input, Injectable, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum SPINNER_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private readonly _visible$ = new BehaviorSubject<boolean>(false);
  visible$ = this._visible$.asObservable();

  show(): void {
    this._visible$.next(true);
  }

  hide(): void {
    this._visible$.next(false);
  }
}

@Component({
  standalone: false,
  selector: 'app-spinner',
  template: `
    <div
      *ngIf="isVisible"
      [class.fullscreen]="isFullscreen"
      class="spinner-overlay"
    >
      <div class="spinner-content">
        <div class="spinner-gear"></div>
        <p>Cargando datos...</p>
      </div>
    </div>
  `,
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() isVisible = false;
  @Input() isFullscreen = false;
  @Input() size: SPINNER_SIZES = SPINNER_SIZES.MEDIUM;
  @Input() color1 = '#000';
}

@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule],
  exports: [SpinnerComponent]
})
export class SpinnerModule {}
